import { type Item } from "@src/api";

/**
 * Чистые функции по работе со списком item ids.
 */

/**
 * Возвращает ids из total_ids, которых нет в found_ids (разница множеств).
 *
 * @param total_ids - полный список id элементов
 * @param found_ids - список id уже найденных элементов
 * @returns массив id элементов, которые не входят в found_ids
 */
export function getNotFoundItemIds(total_ids: string[], found_ids: string[]): string[] {
  const found_set = new Set(found_ids);
  return total_ids.filter((id) => !found_set.has(id));
}

/**
 * Превращает массив в объект «ключ — значение».
 *
 * @param arr - исходный массив
 * @param getKey - функция, возвращающая ключ для элемента
 * @returns объект Record<key, T>, где ключ — результат getKey(item)
 */
export function itemListToMap(item_list: Item[]): Record<string, Item> {
  const map: Record<string, Item> = {};

  for (const item of item_list) {
    map[item.item_id] = item;
  }

  return map;
}
